import ABI from "src/contract-logic/abis/NFTTreasureMapABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Reader, getWeb3Sender } from "src/wallet-connection";

function getContractTreasureMap(contractAddress) {
  const web3Sender = getWeb3Sender();
  const web3Reader = getWeb3Reader();
  var contractReader = new web3Reader.eth.Contract(ABI, contractAddress);
  if (web3Sender) {
    var contractSender = new web3Sender.eth.Contract(ABI, contractAddress);
  }
  return {
    getSuccessRate: async (rarity, collectionId) => {
      const successRate = await contractReader.methods.getSuccessRate(rarity, collectionId).call();
      return successRate;
    },
    getDeployTimestamp: async (collectionId) => {
      const deployTimestamp = await contractReader.methods.getDeployTimestamp(collectionId).call();
      return parseInt(deployTimestamp);
    },
    getTokenOfOwnerBalance: async (address) => {
      const tokenOfOwnerBalance = await contractReader.methods.getTokenOfOwnerBalance(address).call();
      return parseInt(tokenOfOwnerBalance);
    },
    getTreasureMapCount: async (rarity) => {
      try {
        const treasureMapCount = await contractReader.methods.getTreasureMapCount(rarity).call();
        return parseInt(treasureMapCount);
      } catch (err) {
        console.error(err);
      }
    },
    deploy: async (dispatch, address, collectionId, ticketArray) => {
      const emit = contractSender.methods.deploy(collectionId, ticketArray).send({ from: address });
      handleEmit(dispatch, emit, "Deploy");
      await emit;
    },
    abandon: async (dispatch, address, collectionId) => {
      const emit = contractSender.methods.abandon(collectionId).send({ from: address });
      handleEmit(dispatch, emit, "Abandon");
      const res = await emit;
      const treasureMapAbandoned = res.events.TreasureMapAbandoned;
      return {
        exp: treasureMapAbandoned.returnValues.experience,
        status: parseInt(treasureMapAbandoned.returnValues.status),
      };
    },
    withdraw: async (dispatch, address, collectionId) => {
      const emit = contractSender.methods.withdraw(collectionId).send({ from: address });
      handleEmit(dispatch, emit, "Withdraw");
      const res = await emit;
      const treasureMapCompleted = res.events.TreasureMapCompleted;
      const reward = parseInt(treasureMapCompleted.returnValues.status);
      return {
        exp: treasureMapCompleted.returnValues.experience,
        reward,
        status: reward >= 1 ? 1 : 0,
      };
    },
    getTreasureMapDuration: async () => {
      const treasureMapDuration = await contractReader.methods.getTreasureMapDuration().call();
      return parseInt(treasureMapDuration);
    },
    isOnDuty: async (collectionId) => {
      const isOnDuty = await contractReader.methods.isOnDuty(collectionId).call();
      return isOnDuty;
    },
    getTreasureMapPrice: async () => {
      const treasureMapPrice = await contractReader.methods.getTreasureMapPrice().call();
      return parseInt(treasureMapPrice);
    },
  };
}

export default {
  ABI,
  getContractTreasureMap,
};
